import React, {useState} from "react";

import { graphql } from 'gatsby';
import { ThemeProvider } from 'styled-components'
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Hidden from '@material-ui/core/Hidden';
import Grid from "@material-ui/core/Grid";

import Link from "../components/Link";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import RightContainer from "../components/RightContainer";
import MUIDrawer from "../components/Drawer";
import Pagination from "../components/Pagination";
import {MenuContext} from '../components/PostUtils';
import theme from "../theme.js";

export const query = graphql`
query INDEX_TEMPLATE_QUERY($skip: Int!, $limit: Int!) {
  site {
    siteMetadata {
      title
      description
      url
    }
  }
  allMarkdownRemark(
    sort: {fields: [frontmatter___date], order: DESC}
    filter: {frontmatter: {ispublished: {nin: false}, ispage: {nin: true}}}
    limit: $limit
    skip: $skip
  ) {
    nodes {
      id
      excerpt(pruneLength: 250)
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        slug
        tags
      }
    }
  }
}
`;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
  },
  container: {
    flexGrow: 1,
  },
  grid: {
    height: "100vh",
  },
  topgrid: {
    marginTop: "10px",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  drawerPaper: {
    width: '100%',
  },
}));

const ContentDiv = styled.div`
  flex: 1;
  max-width: 700px;
  
  ${props => props.theme.breakpoints.down("xs")} {
    max-width: 100%;
    width: 100%;
  }
`;

const ContainerDiv = styled.div`
  flex-grow: 1;
  padding-left: 35px;
  padding-right: 35px;
  min-height: 100vh;
  background: #FAF9F7;
  
  ${props => props.theme.breakpoints.between("sm", "xl")} {
    padding-left: 40px;
    padding-right: 40px;
  }
  ${props => props.theme.breakpoints.down("xs")} {
    padding-left: 20px;
    padding-right: 20px;
  }
  ${props => props.theme.breakpoints.up("xl")} {
    max-width: 1200px;
    margin: 0 auto;
  }
`;

const PostContainer = styled.div`
  margin-right: auto;
  margin-left: auto;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 4rem;
  max-width: 1000px;
  width: 100%;
  padding: 0;
 
  ${props => props.theme.breakpoints.down("xs")} {
    margin-top: 1rem; 
    margin-right: 0;
    margin-left: 0;
    padding: 0;
    min-height: auto;
    min-width: auto;
  }
`;

const IndexPostListItem = styled(ListItem)`
  & .myprimary {
    color: red;
    font-family: Old Standard TT, serif;
    font-weight: bold;
    font-size: 2rem;
    color: #4c494f;
  }  
  
  & p.mysecondary {
    font-family: Lora,sans serif;
  }

  &:hover {
    text-decoration: none;
  }
`;

const IndexPostListItemText = styled(ListItemText)`
  font-family: Old Standard TT, serif;
  font-size: 2rem;
  font-weight: bold;

  ${props => props.theme.breakpoints.down("xs")} {
    font-size: 2.2em;
    font-weight: bold;
  }
`;

const IndexPostDate = styled.div`
  display: flex;
  flex-direction: 1;
  color: #AD5843;
  font-family: Open Sans, sans-serif;
  font-size: 0.85rem;
  font-weight: 500;
  font-variant: small-caps;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 0.75rem;
`;

const IndexStyledPostLink = styled(Link)`
  font-family: Old Standard TT, serif;
  font-weight: bold;
  color: #AD5843;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1em;
  -webkit-font-smoothing: subpixel-antialiased !important; 
  text-rendering:optimizeLegibility !important;
  ${props => props.theme.breakpoints.down("xs")} {
    letter-spacing: -0.1rem;
  }  
`;

const PostContentContainer = styled.div`
  max-width: 700px;
  margin: 0 0 3rem 0;
  border-bottom: 1px solid rgba(178, 94, 72, 0.2);
  padding-bottom: 2rem;
  width: 100%;
  
  &:last-child {
    border-bottom: none;
  }
`;

const PageTitle = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

const PostTitle = styled.h2`
  font-family: Old Standard TT, serif;
  font-weight: bold;
  font-size: 2.2rem;
  color: #4c494f;
  margin-bottom: 1.2rem;
  margin-top: 0;
  line-height: 1.25;
  letter-spacing: -0.02em;
  text-wrap: balance;
  font-feature-settings: "liga", "kern";
  
  ${props => props.theme.breakpoints.down("xs")} {
    font-size: 2.1rem;
    letter-spacing: -0.01em;
  }
`;

const PostContent = styled.div`
  font-family: Lora, serif;
  font-size: 1.05rem;
  line-height: 1.75;
  color: #333;
  margin-top: 0;
  font-feature-settings: "liga", "kern";
  
  p {
    margin-bottom: 1.5rem;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: Old Standard TT, serif;
    margin-top: 2.5rem;
    margin-bottom: 1.2rem;
    color: #4c494f;
    line-height: 1.3;
    font-feature-settings: "liga", "kern";
  }
  
  blockquote {
    background: #FAF9F7;
    border-left: 4px solid #AD5843;
    margin: 2rem 0;
    padding: 1.2rem 1.5rem;
    font-style: italic;
    font-size: 1.05em;
    color: #555;
    border-radius: 0 4px 4px 0;
    
    p:last-child {
      margin-bottom: 0;
    }
  }
  
  code {
    background-color: #f8f8f8;
    padding: 0.2rem 0.5rem;
    border-radius: 4px;
    font-size: 0.9rem;
    color: #AD5843;
    font-family: "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace;
  }
  
  pre {
    background-color: #f8f8f8;
    padding: 1.2rem;
    border-radius: 6px;
    overflow-x: auto;
    margin: 2rem 0;
    border: 1px solid #e8e8e8;
  }
  
  a {
    color: #AD5843;
    text-decoration: none;
    transition: color 0.2s ease;
    
    &:hover {
      color: #9C4235;
      text-decoration: underline;
    }
  }
  
  img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    margin: 2rem auto;
    display: block;
    
    ${props => props.theme.breakpoints.down("xs")} {
      margin: 1.5rem auto;
      border-radius: 6px;
    }
  }
`;

const ReadArticleLink = styled(Link)`
  color: #9C4235;
  font-family: Open Sans, sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  text-underline-offset: 0.15em;
`;

export default function IndexTemplate({ data, pageContext }) {
  const classes = useStyles(theme);
  const [isOpen, setIsOpen] = useState(false);
  const { currentPage, numPages } = pageContext;

  return (
    <Layout>
      <MenuContext.Provider value={{isOpen: isOpen, setIsOpen: setIsOpen}}>
        <Hidden smUp>
          <MUIDrawer/>
        </Hidden>
        <Seo
          title={data.site.siteMetadata.title}
          description={data.site.siteMetadata.description}
        />
        <ThemeProvider theme={theme}>
          <ContainerDiv>
            <PostContainer>
              <Hidden smUp>
                <RightContainer/>
              </Hidden>
              
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '3rem', width: '100%' }}>
              <ContentDiv>
                  <PageTitle>Writing by Viksit Gaur</PageTitle>
                  {
                    data.allMarkdownRemark.nodes.map(({ excerpt, frontmatter }) => {
                      return (
                        <PostContentContainer key={frontmatter.slug}>
                          <IndexPostDate>
                            {frontmatter.date}
                          </IndexPostDate>
                          <Link to={frontmatter.slug} style={{ 
                            color: '#AD5843',
                            textDecoration: 'none',
                            display: 'block',
                            padding: 0,
                            margin: 0,
                            textIndent: 0
                          }}>
                            <PostTitle>
                              {frontmatter.title}
                            </PostTitle>
                          </Link>
                          <PostContent><p>{excerpt}</p></PostContent>
                          <ReadArticleLink to={frontmatter.slug}>Read article →</ReadArticleLink>
                        </PostContentContainer>
                      );
                    })
                  }
                  <Pagination currentPage={currentPage} numPages={numPages} />
                </ContentDiv>
                
                <Hidden xsDown>
                  <div style={{ flexShrink: 0, width: '200px' }}>
                    <RightContainer/>
                  </div>
                </Hidden>
              </div>
            </PostContainer>
          </ContainerDiv>
        </ThemeProvider>
      </MenuContext.Provider>   
    </Layout>
  );
}
